<div class="grid-list mx-auto px-2">
    <h3 class="text-center" *ngIf="globals.configuracion.front.cart.productos.length == 0">No ha agregado productos</h3>

    <div *ngIf="globals.configuracion.front.cart.productos.length > 0">
        <div *ngFor="let producto of globals.configuracion.front.cart.productos; let i = index;">
            <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                    <div class="d-flex m-0 my-5 cursor-pointer">
                        <div class="pe-3">
                            <div class="box-img">
                                <img class="img-producto" *ngIf="producto.imagenes.length > 0" [src]="producto.imagenes[0].med">
                                <img class="img-producto" *ngIf="producto.imagenes.length == 0" src="/assets/img/producto-sin-imagen.svg">
                            </div>
                        </div>
                        <div class="flex-grow-1">
                            <div class="mb-1">{{ producto.description_clear }}</div>
                            <div class="sku">SKU: {{ producto.stockid }}</div>
                        </div>
                        <div class="ps-3">
                            <div>${{ producto.precio_final_con_impuesto_format }}</div>
                        </div>
                    </div>
                    <div class="row justify-content-center text-center">
                        <div class="col-6">
                            <strong>Cantidad</strong>
                        </div>
                        <div class="col-6">
                            <strong>Subtotal</strong>
                        </div>
                    </div>
                    <div class="row justify-content-center text-center">
                        <div class="col-6">
                            <input type="number" #campoDeEntrada min="1" step="1" [(ngModel)]="producto.cantidad" (input)="setFront()" [value]="producto.cantidad" class="input-cantidad" />
                        </div>
                        <div class="col-6">
                            {{ formatter.format(producto.precio_final_con_impuesto * producto.cantidad) }}
                        </div>
                    </div>
                </div>
                <div>
                    <button mat-icon-button color="warn" (click)="eliminarProducto(i)">
                        <mat-icon>remove_circle</mat-icon>
                    </button>
                </div>
            </div>
            <mat-divider class="my-2"></mat-divider>
        </div>
        <!--
        <div class="text-center">
            <strong>Total: </strong><span>{{ globals.configuracion.front.cart.total }}</span>
        </div>
        -->
    </div>
    <!--
    <table *ngIf="globals.configuracion.front.cart.productos.length > 0" mat-table [dataSource]="globals.configuracion.front.cart.productos" class="table-list w-100">
        <ng-container matColumnDef="imagen">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <img class="img-producto" *ngIf="element.imagenes.length > 0" [src]="element.imagenes[0].med">
                <img class="img-producto" *ngIf="element.imagenes.length == 0" src="/assets/img/producto-sin-imagen.svg">
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="descripcion">
            <th mat-header-cell *matHeaderCellDef>Producto</th>
            <td mat-cell *matCellDef="let element">
                <div class="mb-1">{{ element.description_clear }}</div>
                <div class="sku">SKU: {{ element.stockid }}</div>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="precio">
            <th mat-header-cell *matHeaderCellDef class="text-center">Precio</th>
            <td mat-cell *matCellDef="let element" class="text-center">
                ${{ element.precio_final_con_impuesto_format }}
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="cantidad">
            <th mat-header-cell *matHeaderCellDef class="text-center">Cantidad</th>
            <td mat-cell *matCellDef="let element" class="text-center">
                <input type="number" min="1" step="1" [(ngModel)]="element.cantidad" (input)="setFront()" [value]="element.cantidad" class="input-cantidad" />
            </td>
            <td mat-footer-cell *matFooterCellDef class="text-end"><strong>Total</strong></td>
        </ng-container>

        <ng-container matColumnDef="subtotal">
            <th mat-header-cell *matHeaderCellDef class="text-center">Sub-total</th>
            <td mat-cell *matCellDef="let element" class="text-center">
                {{ formatter.format(element.precio_final_con_impuesto * element.cantidad) }}
            </td>
            <td mat-footer-cell *matFooterCellDef class="text-center"><strong>{{ globals.configuracion.front.cart.total }}</strong></td>
        </ng-container>

        <ng-container matColumnDef="eliminar">
            <th mat-header-cell *matHeaderCellDef class="text-center"></th>
            <td mat-cell *matCellDef="let element; let i = index;" class="text-center">
                <button mat-icon-button color="warn" (click)="eliminarProducto(i)">
                    <mat-icon>remove_circle</mat-icon>
                </button>
            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['imagen','descripcion','precio','cantidad','subtotal','eliminar']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['imagen','descripcion','precio','cantidad','subtotal','eliminar']"></tr>
        <tr mat-footer-row *matFooterRowDef="['imagen','descripcion','precio','cantidad','subtotal','eliminar']"></tr>
    </table>
    -->

</div>
